// src/components/home/Hero.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../../styles/variables';
import { useModal } from '../../contexts/ModalContext';

const HeroSection = styled.section`
  background-image: url('../../assets/images/main_hero_section.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  padding: 120px 0 80px 0;
  margin-top: 64px;
  color: ${colors.white};
  height: 476px;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
`;

const HeroContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 0;
  position: relative;
  z-index: 2;
  @media (max-width: 600px) {
    padding: 12px;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    padding-left: 32px;
    padding-right: 32px;
  }
`;

const HeroContent = styled.div`
  max-width: 600px;
  text-align: left;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  @media (max-width: 768px) {
    text-align: left;
    margin-bottom: 48px;
  }
`;

const HeroTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 24px;
  color: ${colors.white};
  transition: opacity 0.5s;
  opacity: ${props => props.isVisible ? 1 : 0};
  min-height: 120px;
  
  @media (max-width: 768px) {
    font-size: 36px;
    min-height: 72px;
  }
`;

const HeroDescription = styled.p`
  font-size: 18px;
  color: ${colors.white};
  margin-bottom: 32px;
  transition: opacity 0.5s;
  opacity: ${props => props.isVisible ? 1 : 0};
  min-height: 72px;
`;

const Button = styled.button`
  display: inline-block;
  background-color: ${colors.secondary};
  color: ${colors.white};
  padding: 16px 32px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: background-color 0.2s;
  width: 240px;
  max-width: 100%;
  text-align: center;
  
  &:hover {
    background-color: #00a759;
  }

  @media (max-width: 600px) {
    display: block;
    margin: 0 auto 24px auto;
  }
  @media (min-width: 601px) and (max-width: 1024px) {
    margin-left: 0;
    margin-right: 0;
    display: inline-block;
    width: 200px;
  }
`;

const SlideDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
`;

const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.active ? colors.secondary : 'rgba(255, 255, 255, 0.5)'};
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${colors.secondary};
  }
`;

const slides = [
  {
    title: "AI와 함께하는 실무 중심 프로그래밍 교육",
    description: "현업에서 바로 활용 가능한 AI 도구들과 함께, 더 빠르고 효율적인 개발 방법을 배워보세요."
  },
  {
    title: "개인별 수준에 맞춘 1:1 맞춤형 교육으로 빠른 성장",
    description: "현업 멘토와 함께 실전 프로젝트로 실력을 단기간에 끌어올릴 수 있습니다."
  },
  {
    title: "취업에 최적화된 실전 커리큘럼",
    description: "실무 프로젝트와 포트폴리오 중심의 교육으로 IT 취업 시장에서 경쟁력을 갖춘 인재로 성장하세요."
  },
  {
    title: "실업계·대학생 전공자를 위한 맞춤 교육",
    description: "다양한 배경의 학습자를 위한 맞춤형 커리큘럼과 멘토링으로 여러분의 목표를 실현하세요."
  }
];

const Hero = () => {
  const { openConsultationModal } = useModal();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
        setIsVisible(true);
      }, 500);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setIsVisible(false);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsVisible(true);
    }, 500);
  };

  return (
    <HeroSection>
      <HeroContentWrapper>
        <HeroContent>
          <HeroTitle isVisible={isVisible}>{slides[currentSlide].title}</HeroTitle>
          <HeroDescription isVisible={isVisible}>{slides[currentSlide].description}</HeroDescription>
          <Button onClick={openConsultationModal}>교육상담 신청하기</Button>
          <SlideDots>
            {slides.map((_, index) => (
              <Dot
                key={index}
                active={currentSlide === index}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </SlideDots>
        </HeroContent>
      </HeroContentWrapper>
    </HeroSection>
  );
};

export default Hero;